export default "__VITE_ASSET__Bkl2Csps__"